// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__u_Yoe","title":"Info_title__Qvx1G","selects":"Info_selects__3QJF5","requiredAsterisk":"Info_requiredAsterisk__3UUC6"};